import { TradableTransaction } from "./tradable_transaction";

export class DerivativeTransaction extends TradableTransaction {
	// TradableTransaction override:

	public getContactId(): string {
		return "";
	}

	public getDestinationTag(): string {
		return "";
	}

	public getDtType(): string {
		return "";
	}

	public getPurposeText(): string {
		return "";
	}

	public isExternal(): boolean {
		return false;
	}

	public get isStorageFee(): boolean {
		return false;
	}

	// Transaction override:

	public hasAction(cancel: boolean): boolean {
		return false;
	}

	public isCancelable(): boolean {
		return false;
	}
}
